// extracted by mini-css-extract-plugin
export default {"mapControls":"map-controls_mapControls__wPmeg","mapZoomButton":"map-controls_mapZoomButton__KAprg"};